const customStylesSelect = {
    control: (base, state) => ({
        ...base,
        backgroundColor: state.isDisabled ? '#E9ECEF' : 'white',
        color: state.isDisabled ? '#6c757d' : '#212529',
        borderColor: state.isFocused ? '#2b97be' : '#ced4da',
        cursor: state.isDisabled ? 'not-allowed' : 'default',
        opacity: state.isDisabled ? 1 : base.opacity,
        boxShadow: state.isFocused
            ? '0 0 0 0.2rem rgba(43, 151, 190, 0.15)'
            : 'none',
        '&:hover': {
            borderColor: '#2b97be',
        },
        minHeight: 38,
        transition: 'border-color 0.2s',
    }),
    singleValue: (base) => ({
        ...base,
        color: '#212529',
    }),
    placeholder: (base) => ({
        ...base,
        color: '#6c757d',
    }),
    input: (base, state) => ({
        ...base,
        color: state.isDisabled ? '#6c757d' : '#212529',
    }),
    option: (base, state) => ({
        ...base,
        color: state.isSelected ? 'white' : '#212529',
        backgroundColor: state.isSelected
            ? '#2b97be'
            : state.isFocused
            ? '#e1f5fb'
            : 'white',
        fontWeight: state.isSelected ? 600 : 400,
        borderRadius: 0,
        transition: 'background-color 0.2s, color 0.2s',
    }),
    menu: (base) => ({
        ...base,
        zIndex: 5,
    }),
    menuList: (base) => ({
        ...base,
        padding: 0,
        backgroundColor: 'white',
    }),
};

export default customStylesSelect;
